module.exports = __webpack_public_path__ + "img/湖南普菲克生物科技有限公司.17a2346a.png";